'use client'

import { useState } from 'react'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { EnsureBalanceActivated } from '@marketplace-web/balance-activation/balance-activation-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import WeHaveMetConfirmationModal from '../WeHaveMetConfirmationModal'

const WeHaveMet = (props: ConversationActionProps) => {
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id

  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)

  const handleConfirmationOpen = () => setIsConfirmationOpen(true)

  const handleConfirmationClose = () => setIsConfirmationOpen(false)

  const { primary, title, inverse, theme, size } = props

  if (!transactionId) return null

  return (
    <>
      <EnsureBalanceActivated {...props} onSuccess={handleConfirmationOpen}>
        <ConversationActionButton
          text={title}
          primary={primary}
          size={size}
          theme={theme}
          inverse={inverse}
          onClick={handleConfirmationOpen}
        />
      </EnsureBalanceActivated>
      <WeHaveMetConfirmationModal
        isOpen={isConfirmationOpen}
        onClose={handleConfirmationClose}
        transactionId={transactionId}
      />
    </>
  )
}

export default WeHaveMet
